export default __webpack_public_path__ + "static/media/moldura-3-NOVO-site.bd7d6177.mp4";